import React from "react";
import { Grid } from "@mui/material";
import RmfHeatMapChart from "./RmfHeatMapChart";
import RmfRiskTypeBarChart from "./RmfRiskTypeBarChart";
import RmfResolutionGauge from "./RmfResolutionGauge";
import RmfTicketSummaryCards from "./RmfTicketSummaryCards";

const RmfAnalytics: React.FC<{ permissions?: any }> = () => {
  return (
    <>
      <Grid container spacing={3} sx={{ marginTop: "2em" }}>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} component="div">
          <RmfHeatMapChart />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 6 }} component="div">
          <RmfRiskTypeBarChart />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 3 }} component="div">
          <RmfResolutionGauge />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 3 }} component="div">
          <RmfTicketSummaryCards />
        </Grid>
      </Grid>
      {/* <Card sx={{ marginTop: "2em" }}>
        <CardHeader title="Open RMF Risks" />
        <CardContent
          sx={{
            padding: "0",
            "&:last-child": {
              paddingBottom: "0",
            },
          }}
        >
          <List
            disableSyncWithLocation
            resource="rmf/risks"
            actions={false}
            title={false}
            empty={false}
            perPage={25}
            sort={{ field: "expirationDate", order: "DESC" }}
            filter={{ status: "open" }}
          >
            <Datagrid bulkActionButtons={false} rowClick="show">
              <TextField source="name" />
              <TextField source="division" />
              <TextField source="department" />
              <TextField source="assignee" />
              <SelectField
                source="severity"
                choices={RISK_SEVERITY_CHOICES}
                label="Severity"
              />
              <SeverityChipField source="riskLevel" resource="rmf/risks" />
              <DateField source="expirationDate" label="SLA (Expiration)" />
            </Datagrid>
          </List>
        </CardContent>
      </Card> */}
    </>
  );
};

export default RmfAnalytics;
